<template>
    <div class="bg-blue p-4 text-white">
        <slot></slot>
    </div>
</template>

<script>
export default {
    
    data() {
        return {

        }
    },

    mounted() {

    },

    methods: {
        

    },

}
</script>
